// Lazy load Swiper only when needed
let swiperTrainers;
let Swiper, Navigation, Pagination, Autoplay;

// Function to load Swiper dynamically
async function loadSwiper() {
  if (!Swiper) {
    // Dynamic imports - webpack will create separate chunks
    const [swiperModule, { Navigation: Nav, Pagination: Pag, Autoplay: Auto }] = await Promise.all([
      import(/* webpackChunkName: "swiper" */ 'swiper'),
      import(/* webpackChunkName: "swiper" */ 'swiper/modules')
    ]);

    // Import CSS dynamically
    await Promise.all([
      import(/* webpackChunkName: "swiper-css" */ 'swiper/css'),
      import(/* webpackChunkName: "swiper-css" */ 'swiper/css/navigation'),
      import(/* webpackChunkName: "swiper-css" */ 'swiper/css/pagination')
    ]);

    Swiper = swiperModule.default;
    Navigation = Nav;
    Pagination = Pag;
    Autoplay = Auto;
  }
  return { Swiper, Navigation, Pagination, Autoplay };
}

document.addEventListener("turbo:load", async function () {
  // Only load Swiper if carousel exists on the page
  if (!document.querySelector('.swiper--trainers')) return;

  const { Swiper, Navigation, Pagination } = await loadSwiper();

  const breakpointSm = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-sm').replace("px", "");
  const breakpointMd = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-md').replace("px", "");
  const breakpointLg = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace("px", "");

  swiperTrainers = new Swiper('.swiper--trainers', {
    modules: [Navigation, Pagination],
    grabCursor: false,
    slidesPerGroup: 2,
    slidesPerView: 2.5,
    spaceBetween: 30,
    speed: 500,

    breakpoints: {
      [breakpointSm]: {
        allowTouchMove: true,
        slidesPerGroup: 3,
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      [breakpointMd]: {
        allowTouchMove: false,
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 56,
      },
      [breakpointLg]: {
        allowTouchMove: false,
        slidesPerGroup: 5,
        slidesPerView: 5,
        spaceBetween: 56,
      }
    },

    pagination: {
      el: '.ws-swiper-pagination',
      type: 'fraction'
    },

    // Navigation arrows
    navigation: {
      nextEl: '.ws-swiper-button-next',
      prevEl: '.ws-swiper-button-prev',
    },
  });
});

document.addEventListener("turbo:before-cache", function () {
  if (swiperTrainers && swiperTrainers.mounted) swiperTrainers.destroy();
});

let swiperTeam;
document.addEventListener("turbo:load", async function () {
  // Only load Swiper if carousel exists on the page
  if (!document.querySelector('.swiper--team')) return;

  const { Swiper, Navigation, Pagination } = await loadSwiper();

  const breakpointSm = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-sm').replace("px", "");
  const breakpointMd = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-md').replace("px", "");
  const breakpointLg = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace("px", "");

  swiperTeam = new Swiper('.swiper--team', {
    modules: [Navigation, Pagination],
    grabCursor: false,
    slidesPerGroup: 2,
    slidesPerView: 2.5,
    spaceBetween: 30,
    autoHeight: true,
    speed: 500,

    breakpoints: {
      [breakpointSm]: {
        allowTouchMove: true,
        slidesPerGroup: 3,
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      [breakpointMd]: {
        allowTouchMove: false,
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 56,
      },
      [breakpointLg]: {
        allowTouchMove: false,
        slidesPerGroup: 3,
        slidesPerView: 3.5,
        spaceBetween: 56,
      }
    },

    pagination: {
      el: '.ws-swiper-pagination',
      type: 'fraction'
    },

    // Navigation arrows
    navigation: {
      nextEl: '.ws-swiper-button-next',
      prevEl: '.ws-swiper-button-prev',
    },
  });
});

document.addEventListener("turbo:before-cache", function () {
  if (swiperTeam && swiperTeam.mounted) swiperTeam.destroy();
});

let swiperPartner;
document.addEventListener("turbo:load", async function () {
  // Only load Swiper if carousel exists on the page
  if (!document.querySelector('.swiper--partner')) return;

  const { Swiper, Navigation, Pagination } = await loadSwiper();

  const breakpointSm = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-sm').replace("px", "");
  const breakpointMd = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-md').replace("px", "");
  const breakpointLg = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace("px", "");

  swiperPartner = new Swiper('.swiper--partner', {
    modules: [Navigation, Pagination],
    grabCursor: false,
    slidesPerGroup: 2,
    slidesPerView: 2.5,
    spaceBetween: 30,
    autoHeight: true,
    speed: 500,

    breakpoints: {
      [breakpointSm]: {
        allowTouchMove: true,
        slidesPerGroup: 3,
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      [breakpointMd]: {
        allowTouchMove: false,
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 56,
      },
      [breakpointLg]: {
        allowTouchMove: false,
        slidesPerGroup: 4,
        slidesPerView: 4.5,
        spaceBetween: 56,
      }
    },

    pagination: {
      el: '.ws-swiper-pagination',
      type: 'fraction'
    },

    // Navigation arrows
    navigation: {
      nextEl: '.ws-swiper-button-next',
      prevEl: '.ws-swiper-button-prev',
    },
  });
});

document.addEventListener("turbo:before-cache", function () {
  if (swiperPartner && swiperPartner.mounted) swiperPartner.destroy();
});

let swiperEvents;
document.addEventListener("turbo:load", async function () {
  let selector = ".swiper--events";
  if (!document.querySelector(selector)) return;

  const { Swiper, Navigation, Pagination } = await loadSwiper();

  const breakpointSm = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-sm').replace("px", "");
  const breakpointMd = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-md').replace("px", "");
  const breakpointLg = getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace("px", "");

  swiperEvents = new Swiper(selector, {
    modules: [Navigation, Pagination],
    grabCursor: false,
    allowTouchMove: true,
    preventClicks: false,
    preventClicksPropagation: false,
    slidesPerGroup: 1,
    slidesPerView: 1.2,
    spaceBetween: 16,
    speed: 500,

    breakpoints: {
      [breakpointSm]: {
        allowTouchMove: true,
        slidesPerGroup: 2,
        slidesPerView: 2.2,
      },
      [breakpointMd]: {
        allowTouchMove: false,
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 16,
      },
      [breakpointLg]: {
        allowTouchMove: false,
        slidesPerGroup: 5,
        slidesPerView: 5,
        spaceBetween: 16,
      }
    },

    pagination: {
      el: '.ws-swiper-pagination',
      type: 'fraction'
    },

    // Navigation arrows
    navigation: {
      nextEl: '.ws-swiper-button-next',
      prevEl: '.ws-swiper-button-prev',
    },
  });

  document.querySelectorAll(".swiper--events .ws-filters input[name=location]").forEach(function(elm) {
    elm.addEventListener("change", function() {
      let filter = this.value;

      if (filter === "all") {
        document.querySelectorAll(".swiper--events .swiper-slide[data-filter]").forEach(function(el) {
          el.style.display = "block";
        });
      } else {
        document.querySelectorAll(`.swiper--events .swiper-slide:not([data-filter='${filter}'])`).forEach(function(el) {
          el.style.display = "none";
        });
        document.querySelectorAll(`.swiper--events .swiper-slide[data-filter='${filter}']`).forEach(function(el) {
          el.style.removeProperty("display");
        });
      }

      swiperEvents.update();
    });
  });
});

document.addEventListener("turbo:before-cache", function () {
  if (swiperEvents && swiperEvents.mounted) swiperEvents.destroy();
});

let swiperTestimonials;
document.addEventListener("turbo:load", async function () {
  let selector = ".swiper--testimonials";
  if (!document.querySelector(selector)) return;

  const { Swiper, Navigation, Pagination, Autoplay } = await loadSwiper();

  swiperTestimonials = new Swiper(selector, {
    modules: [Navigation, Pagination, Autoplay],
    grabCursor: false,
    allowTouchMove: false,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 800,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },

    pagination: {
      el: '.ws-swiper-pagination',
      type: 'fraction'
    },

    // Navigation arrows
    navigation: {
      nextEl: '.ws-swiper-button-next',
      prevEl: '.ws-swiper-button-prev',
    },
  });
});

document.addEventListener("turbo:before-cache", function () {
  if (swiperTestimonials && swiperTestimonials.mounted) swiperTestimonials.destroy();
});
